<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{ 'Reports'|translate }}
                </v-card-title>
                <v-card-actions>
                    <span style="width:300px;" class="ml-2"><v-text-field class="mr-4" clearable v-model="search" type="text"
                                                             :label="'Keyword filter'|translate"></v-text-field></span>
                    <v-spacer></v-spacer>

                    <v-btn class="accent mr-2" @click="editedItem=null;dialog=true" :disabled="!$can('update', 'Report')">
                        <v-icon small class="mr-2">fa-plus</v-icon>
                        {{ 'Add Record'|translate }}
                    </v-btn>
                    <!--                    <v-btn class="accent" @click="smsDialog=true"><v-icon small class="mr-2">fa-phone</v-icon> {{'Test Message'|translate}}</v-btn>-->
                    <report-config-dialog v-model="dialog" :item="editedItem"
                                          v-on:doreload="refresh()"></report-config-dialog>
                    <sms-dialog v-model="smsDialog"></sms-dialog>
                </v-card-actions>

                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="rules"
                        class="elevation-1"
                        :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        :items-per-page="25"
                        :search="search2"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.title }}</td>
                            <td class="text-xs-left">{{ props.item.severity_levels }}</td>
                            <td class="text-xs-left">{{ props.item.topic }}</td>
                            <td class="text-xs-left">{{ props.item.email_frequency }}</td>
                            <td class="text-xs-left">{{
                                    props.item.report_active ? $options.filters.translate('yes') : $options.filters.translate('no')
                                }}
                            </td>
                            <td class="text-xs-left">{{ props.item.emails }}</td>
                            <td class="justify-center layout px-0">
                                <v-icon
                                    small
                                    class="mr-2"
                                    @click="editItem(props.item)"
                                >
                                    fa-edit
                                </v-icon>
                                <v-icon
                                    small
                                    @click="deleteItem(props.item)"
                                >
                                    fa-trash
                                </v-icon>
                            </td>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize">{{ 'Refresh'|translate }}</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getReportConfig, deleteReportConfig} from '../helper'
import ReportConfigDialog from '../components/recordconfig/ReportConfigDialog'
import SmsDialog from "../components/recordconfig/SmsDialog";

export default {
    name: 'ReportConfig',
    components: {ReportConfigDialog, SmsDialog},
    data() {
        return {
            dialog: false,
            smsDialog: false,
            headers: [
                {
                    text: this.$options.filters.translate('Title'),
                    align: 'left',
                    sortable: true,
                    value: 'title'
                },
                {text: this.$options.filters.translate('Severity Level(s)'), value: 'severity_levels'},
                {text: this.$options.filters.translate('Topic'), value: 'topic'},
                {text: this.$options.filters.translate('Frequency'), value: 'email_frequency'},
                {text: this.$options.filters.translate('Active'), value: 'report_active'},
                {text: this.$options.filters.translate('Distribution List'), value: 'emails', sortable: false},
            ],
            rules: [],
            editedItem: {},
            search: '',
            search2: ''
        }
    },
    watch: {
        search() {
            this.debounce(this.syncSearches, 500);
        }
    },
    mounted() {
        this.initialize()
    },
    methods: {
        initialize() {
            this.refresh()
        },

        editItem(item) {
            this.editedItem = JSON.parse(JSON.stringify(item))
            this.dialog = true
        },

        async deleteItem(item) {
            const index = this.rules.indexOf(item)
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?'))) {
                this.rules.splice(index, 1)
                await deleteReportConfig({
                    'reportconfig_id': item.reportconfig_id
                })
                this.refresh()
            }
        },
        async refresh() {
            let df = await getReportConfig({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            })
            this.rules = df['result']
        },
        syncSearches() {
            this.search2 = this.search
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
    }
}
</script>

<style scoped>

</style>
